import { parselinkConfigurator } from './helpers/helpers.js';
import { useBloomreach, useBrPageContext } from '../context/context.js';
import { getContentByRef } from '../utils/get-content-by-ref.js';

const useBloomreachCartConfiguration = ()=>{
    var ref, ref1, ref2;
    const { pageModel  } = useBloomreach();
    const page = useBrPageContext();
    const ref3 = (ref = pageModel === null || pageModel === void 0 ? void 0 : pageModel.page.models) === null || ref === void 0 ? void 0 : (ref1 = ref.cartConfiguration) === null || ref1 === void 0 ? void 0 : ref1.$ref;
    const content1 = getContentByRef(ref3, pageModel);
    const { title: title1 , description , linkConfigurator1 , linkConfigurator2 , policyItem  } = content1 !== null && content1 !== void 0 ? content1 : {};
    const firstLink = parselinkConfigurator(linkConfigurator1, page);
    const secondLink = parselinkConfigurator(linkConfigurator2, page);
    const policyItems = policyItem && (policyItem === null || policyItem === void 0 ? void 0 : policyItem.length) > 0 ? policyItem === null || policyItem === void 0 ? void 0 : policyItem.map(({ text , url , popupConfig: { content , title  } , icon  })=>({
            text,
            url,
            popupConfig: {
                content,
                title
            },
            icon
        })
    ) : undefined;
    if (!(pageModel === null || pageModel === void 0 ? void 0 : (ref2 = pageModel.page) === null || ref2 === void 0 ? void 0 : ref2.models) || !content1) {
        console.warn(`Cannot find main content for Cart Configuration. Got: ${content1} for $ref: ${ref3}`);
        return;
    }
    return {
        title: title1 || '',
        description: description || '',
        firstLink,
        secondLink,
        policyItems: policyItems || undefined
    };
};

export { useBloomreachCartConfiguration };
//# sourceMappingURL=use-bloomreach-cart-configration.js.map
